export const modifiedGranteeWelcomeContent = {
    granteeWelcomePageLimited: {
        heading: 'Welcome! Accept your limited authority request',
        text1: {
            html: '<p>Follow these steps to accept your access request:</p>\n',
            plaintext: 'Follow these steps to accept your access request:'
        },
        navGetStarted: 'Get started',
        setupOnlineAccessToVgListItem: {
            heading: 'Set up online access to vanguard.com',
            text1: '<p>Have your Social Security number ready. You must have a U.S. address to complete the process online.</p>\n'
        },
        limitedAuthorityLoginEnterPinListItem: {
            heading: 'Log in and enter your unique pin',
            text1: '<p>Use your new credentials and the unique pin provided by the person giving you access.</p>\n'
        },
        limitedAuthorityAcceptAccessRequestListItem: {
            heading: 'Accept your access request',
            text1: '<p>Answer the required regulatory questions and accept the authorization agreement to finalize your acceptance.</p>\n'
        },
        lblEstimatedTimeToComplete: 'Estimated time to complete',
        lblMinutes: '${minutes} minutes'
    },
    granteeWelcomePageInfo: {
        heading: 'Welcome! Accept your information only access request',
        text1: {
            html: '<p>Follow these steps to accept your access request:</p>\n',
            plaintext: 'Follow these steps to accept your access request:'
        },
        navGetStarted: 'Get started',
        setupOnlineAccessToVgListItem: {
            heading: 'Set up online access to vanguard.com',
            text1: '<p>Have your Social Security number ready. You must have a U.S. address to complete the process online.</p>\n'
        },
        infoOnlyLoginWithCredentialsListItem: 'Log in with your new credentials',
        infoOnlyEnterUniquePinListItem: {
            heading: 'Enter your unique pin',
            text1: '<p>Make sure you received your unique pin from the person giving you access. You’ll need it to verify it’s you!</p>\n'
        },
        lblEstimatedTimeToComplete: 'Estimated time to complete',
        lblMinutes: '${minutes} minutes'
    }
}